module.exports = __webpack_public_path__ + "static/media/step2@2x.479d90e9.webm";